export default "__VITE_ASSET__DvYHSIN3__"